export const PAYMENT_SLIP_FILTERS = {
  filteredField: '',
  genericTerm: '',
  productType: '',
  date: [],
  paymentDate: [],
};

export const PAYMENT_SLIP_FILTER_OPTIONS = {
  ORDER_NUMBER: 'PAYMENT_SLIP.FILTER_OPTIONS.ORDER_NUMBER',
  FINAL_CUSTOMER_DOCUMENT: 'PAYMENT_SLIP.FILTER_OPTIONS.FINAL_CUSTOMER_DOCUMENT',
  INVOICE_NUMBER: 'PAYMENT_SLIP.FILTER_OPTIONS.INVOICE_NUMBER',
};

export const PAYMENT_SLIP_PRODUCT_TYPE = {
  ALL: 'PAYMENT_SLIP.PRODUCT_TYPE.ALL',
  HARDWARE: 'PAYMENT_SLIP.PRODUCT_TYPE.HARDWARE',
  SOFTWARE_SERVICE_CLOUD: 'PAYMENT_SLIP.PRODUCT_TYPE.SOFTWARE_SERVICE_CLOUD',
};
